import { Injectable } from '@angular/core';
import { TextConfirmComponent } from '@shared/components/text-confirm/text-confirm.component';
import { corrigirTextoPtBr } from '@shared/util/texto-pt';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private modalService: NzModalService) { }

  confirm(title: string, callback: ((value: any) => void)) {
    this.modalService.confirm({
      nzTitle: corrigirTextoPtBr(title),
      nzOkText: 'Sim',
      nzOnOk: callback,
      nzCancelText: 'Não'
    });
  }

  confirmWithText(title: string, placeholder: string, textHtmlModal: any, callback: ((component: TextConfirmComponent) => void)) {
    const modalOptions: CustomModalOptions<TextConfirmComponent> = {
      nzTitle: corrigirTextoPtBr(title),
      nzOkText: 'Sim',
      nzOnOk: callback,
      nzCancelText: 'Não',
      nzContent: TextConfirmComponent,
      nzClosable: false,
      nzComponentParams: {
        placeholder: placeholder,
        textHtmlModal: textHtmlModal
      }
    };

    this.modalService.create(modalOptions);
  }

  info(title: string, message: string, callback: ((value: any) => void)): void {
    this.modalService.info({
      nzTitle: corrigirTextoPtBr(title),
      nzContent: corrigirTextoPtBr(message),
      nzOnOk: callback
    });
  }

  confirmCustomButtons(title: string, textButtonOk: string, textButtonCancell: string, callback: ((value: any) => void)) {
    this.modalService.confirm({
      nzTitle: corrigirTextoPtBr(title),
      nzOkText: textButtonOk ? textButtonOk : 'Sim',
      nzOnOk: callback,
      nzCancelText: textButtonCancell ? textButtonCancell : 'Não'
    });
  }

  confirmWithTextCustomButtons(title: string, textButtonOk: string, textButtonCancell: string, placeholder: string, textHtmlModal: any, callback: ((component: TextConfirmComponent) => void)) {
    const modalOptions: CustomModalOptions<TextConfirmComponent> = {
      nzTitle: corrigirTextoPtBr(title),
      nzOkText: textButtonOk ? textButtonOk : 'Sim',
      nzOnOk: callback,
      nzCancelText: textButtonCancell ? textButtonCancell : 'Não',
      nzContent: TextConfirmComponent,
      nzClosable: false,
      nzComponentParams: {
        placeholder: placeholder,
        textHtmlModal: textHtmlModal
      }
    };
    this.modalService.create(modalOptions);
  }
}

interface CustomModalOptions<T> extends ModalOptions<T> {
  nzComponentParams?: { placeholder: string; textHtmlModal: any };
}
